// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"3b25d7ba","286":"59924547","453":"b67d2354"}[chunkId] + ".chunk.js";
};